import { SelectOption } from '@indigo-ag/component-module';
import { ActivityType, Grain } from '@indigo-ag/schema';
import i18next from 'core/i18n';

import { text as textUtils } from '../utils/text.util';

export const activityTypeTranslations: { [key in ActivityType]: string } = {
  [ActivityType.GRAIN_PRODUCTION]: i18next.t('grainProduction'),
  [ActivityType.WAREHOUSE_SERVICE]: i18next.t('warehouseService'),
  [ActivityType.OTHER_SERVICES]: i18next.t('otherServices')
};

export const activityTypeOptions: SelectOption<ActivityType>[] = Object.keys(ActivityType).map(activityType => ({
  name: textUtils.toTitleCase(activityTypeTranslations[activityType]),
  value: activityType as ActivityType
}));

export const grainTranslations: { [key in Grain]: string } = {
  [Grain.CORN]: i18next.t('corn'),
  [Grain.COTTON]: i18next.t('cotton'),
  [Grain.SOYBEAN]: i18next.t('soybean')
};
